module.exports = __webpack_public_path__ + "img/29.6d2d66a8.jpg";